import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { forceLogin } from "src/model/services/profile.service";

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error, query) => {
      if (error["response"]?.status === 403) {
        forceLogin();
        return null;
      }
    },
  }),
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (error["response"]?.status === 403) {
        forceLogin();
        return null;
      }
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
